module.exports = __webpack_public_path__ + "img/feedback7-1.12b8c3df.jpg";